<template>
    <div class="flex justify-start items-center py-1 gap-2 font-medium">
        <img class="w-6 h-6 rounded-md border border-gray-200" :src="logo" />
        {{ text }}
    </div>
</template>

<script>
export default {
	name:"Logo-And-Text",
	components:{
	},
	props:{
		logo:{
			type:String
		},	
		text:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>